<template>
  <div :class="[$attrs.class, {'tw-bg-orange-medium tw-text-white': selected}]" @click="handleClick" :data-addon-id="addon.id">
    <div class="tw-font-bold tw-flex">
      <span class="tw-flex-1">
      <template v-if="addon.quantity && addon.quantity > 1">
        {{addon.quantity}}x
      </template> {{addon.name}} <span v-if="addon.cost">(+{{addon.cost.toFixed(2)}})</span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed } from 'vue'
  import { useRouter } from 'vue-router'
  import type Product from '../../classes/Product';

  const props = defineProps<{ 
    addon: Product,
    selected: boolean
  }>();

  // const productImage = ref();

  const emit = defineEmits(['addonToggled'])

  // onMounted(() => {
  //   if (props.product != null && props.product.images) {
  //     let img = props.product.getImageByKey("product_category")

  //     if (img) {
  //       productImage.value = img.url
  //     } else {
  //       productImage.value = 'https://picsum.photos/400/400/?random'
  //     }
  //   }
  // })

  // const buttonPath = computed(() => {
  //   let path = "customize"
    
  //   if (props.product != null && props.product.metadata != null) {
  //     if (props.product.getMetaDataByKey("modifiable") != null && props.product.getMetaDataByKey("modifiable") == false) {
  //       path = "addToBag"
  //     } else if (props.product.getMetaDataByKey("buttonPath") && props.product.getMetaDataByKey("buttonPath") != "customize") {

  //     }
  //   }

  //   return path;
  // })

  const handleClick = () => {
    emit('addonToggled', props.addon)
  }

</script>
